module.exports = __webpack_public_path__ + "media/img/masks/avatar-group-hover-672e50f73963cf97baae196cf2c7a7bd.svg";